import { isNativeView } from '@vm/omega-shared-component-webapp';

import { tryHandleThirdPartyCTANative } from '../../third-party/handle-third-party-cta';

export const setUpNativeConfirm = (productId, clientId) => {
  if (isNativeView()) {
    try {
      if (window?.AndroidInterface) {
        // Define the Android function on the window.AndroidInterface namespace
        window.AndroidInterface.confirm = async url => {
          await tryHandleThirdPartyCTANative(url, productId, clientId);
        };
      }

      if (window?.webkit?.messageHandlers) {
        // Define the IOS function on the window.webkit namespace
        window.webkit.messageHandlers.confirm = async url => {
          await tryHandleThirdPartyCTANative(url, productId, clientId);
        };
      }
    } catch (err) {
      console.error('Error in setUpNativeConfirm', err);
    }
  }
};
